<template>
  <div class="w-full h-full">
    <dash-edit-header v-model="form_name" />
    <div class="h-full flex flex-grow border-t">
      <div class="relative">
        <el-menu
          active-text-color="#303133" default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse"
          @open="handleOpen"
          @close="handleClose"
        >
          <el-menu-item-group v-for="(menu, menu_index) in menus" :key="menu_index">
            <span slot="title">{{ menu.label }}</span>
            <draggable
              class="dragArea list-group"
              :group="{ name: 'people', pull: 'clone', put: false }"
              :list="menu.items"
              :move="onDragMove"
              :clone="cloneWidget"
              @start="onDragStart"
              @end="onDragEnd"
            >
              <el-menu-item
                v-for="(item, item_index) in menu.items"
                :key="`${menu_index}-${item_index}`" class="item"
              >
                <div class="flex items-center" @mousedown="handleMouseDownOnItem(item)">
                  <i :class="`bi ${item.icon} mr-2`" /><span v-show="!isCollapse">{{ item.label }}</span>
                </div>
              </el-menu-item>
            </draggable>
          </el-menu-item-group>
        </el-menu>

        <div class="absolute top-0 -right-2 z-10">
          <button class="border rounded bg-white" @click="isCollapse=!isCollapse">
            <i
              :class="['bi', {'bi-chevron-double-right':isCollapse, 'bi-chevron-double-left': !isCollapse}]"
            />
          </button>
        </div>
      </div>

      <div class="w-full h-full">
        <div class="h-[50px] bg-white">
          <div class="h-full p-0 px-2 border-y flex items-center justify-end">
            <div>
              <el-button>预览</el-button>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </div>
          </div>
        </div>
        <draggable
          :sort="false"
          :draggable="draggable"
          class="w-full h-full"
          group="people"
          :list="elements"
          ghost-class="invisible"
          @change="onDragChange1"
        >
          <editorPan
            v-if="elements.length > 0 || draggable" :key="timer" v-model="elements"
            :scale.sync="canvasConfig.scale" @edit="onEdit"
          />
          <el-empty v-else description="从左侧拖拽或点击添加图表/组件" />
        </draggable>
      </div>
    </div>
    <el-dialog class="source-select" width="40%" title="更改数据源" :visible.sync="SourceDialogVisible">
      <data-source-select v-if="SourceDialogVisible" v-model="form" @cancel="SourceDialogVisible=false" @input="onSourceSelected" />
    </el-dialog>
    <widget-editor v-if="editorVisible" v-model="config" fullscreen :visible.sync="editorVisible" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import DashEditHeader from '@/components/DashEditHeader'
import editorPan from '../../components/dash/editor-panel/Index'
import Draggable from 'vuedraggable'
import axios from 'axios'
import zroute from '../../ziggy'
import DataSourceSelect from '../../components/dash/DataSourceSelect'
import WidgetEditor from '../../components/dash/WidgetEditor'
import {menus} from '../../components/dash/uitls'


export default {
  components: {
    DataSourceSelect,
    DashEditHeader,
    editorPan,
    Draggable,
    WidgetEditor,
  },
  layout: Layout,
  props: {
    dash: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      menus,
      config: {
        fields: [],
        filter: [],
        form: '',
        height: 0,
        width: 0,
        x: 0,
        y: 0,
        type: 'data_table',
      },
      editorVisible: false,
      SourceDialogVisible: false,
      form: {
        id: '',
        name: '',
        icon: '',
      },
      timer: 0,
      app_id: zroute().params.app_id,
      dash_id: zroute().params.dash_id,
      newItem: null,
      draggable: false,
      dragOffsetLeft: 0,
      dragOffsetTop: 0,
      dragWidgetType: '',
      dragLocation: {
        x: 0,
        y: 0,
      },

      elements: this.dash.widgets,
      canvasConfig: {
        scale: 1,
      },
      form_name: this.dash.name,
      isCollapse: false,
    }
  },
  methods: {
    onEdit(config) {
      console.log('onEdit', config)
      this.config = config
      this.editorVisible = true
    },
    onSourceSelected(form) {
      console.log('onSourceSelected', form)
      this.SourceDialogVisible = false
      this.newItem.form = form
      this.newItem.fields = []
      this.newItem.filter = []
      this.elements.push(this.newItem)
      this.timer = Date.now()
      this.config = this.newItem
      this.editorVisible = true
    },
    onSubmit() {
      console.log(this.elements)
      axios.post(zroute('app.dash.save', [this.app_id, this.dash_id]), {
        elements: this.elements,
      }).then(() => {
        this.$message.success('保存成功')
      }).catch(() => {
        this.$message.error('保存失败')
      })
    },
    handleMouseDownOnItem(item) {
      console.log('handleMouseDownOnItem', item)
      this.dragWidgetType = item.type
    },
    cloneWidget(id) {
      console.log('cloneWidget', id)
      return {
        id: '_widget_' + Date.now(),
        title: '表格1',
        type: id.type,
        x: 0,
        y: 0,
        width: 600,
        height: 300,
      }
    },
    onDragMove(e) {
      // if ('offsetLeft' in e.to) {
      // this.dragOffsetLeft = e.to.offsetLeft
      // // }
      // // if ('offsetTop' in this.to) {
      // this.dragOffsetTop = e.to.offsetTop
      // // }
      this.dragLocation = {
        x: e.originalEvent.x - e.to.offsetLeft,
        y: e.originalEvent.y - e.to.offsetTop,
      }
      // this.dragOffsetLeft = this.to.offsetLeft
      // this.dragOffsetTop = this.to.offsetTop
      // console.log('onDragMove', this.dragLocation)
      // return false
    },
    onDragStart(e) {
      this.draggable = true
      // console.log('onDragStart', e)
    },
    onDragEnd(e) {
      this.draggable = false
      // this.elements.push({
      //   id: '_widget_' + Date.now(),
      //   title: '表格1',
      //   type: this.dragWidgetType,
      //   x: e.originalEvent.x - this.dragOffsetLeft,
      //   y: e.originalEvent.y - this.dragOffsetTop,
      //   width: 600,
      //   height: 300,
      // })
      // this.dragLocation = {
      //   x: e.originalEvent.x - this.dragOffsetLeft,
      //   y: e.originalEvent.y - this.dragOffsetTop,
      // }
      console.log('onDragEnd', e, e.item)
    },
    onDragChange1(e) {
      this.SourceDialogVisible = true
      e.added.element.x = this.dragLocation.x
      e.added.element.y = this.dragLocation.y
      this.newItem = e.added.element
      // this.$set(this.elements, e.added.index, e.added.element)
      // this.elements.push(e.added.element)
      this.elements.filter(item => item.id === e.added.element.id).forEach(item => {
        this.elements.splice(this.elements.indexOf(item), 1)
      })
      // this.elements.splice(e.added.newIndex, 1)
      this.timer = Date.now()
      console.log('onDragChange1', e, this.elements)
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}

.el-menu-vertical-demo {
  height: 100%;

  .el-menu-item {
    height: 36.5px;
    line-height: 36.5px;
  }
}

.source-select {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
</style>
